import script from "./LightZoneItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LightZoneItem.vue?vue&type=script&setup=true&lang=js"

import "./LightZoneItem.vue?vue&type=style&index=0&id=6f5f977c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f5f977c"]])

export default __exports__